import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import Random from "../../utils/strings/Random";
import ReactDOM from "react-dom";
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import Select from "../../components/form/Select";
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import PAGES from '../../config/Pages';

const URL_SAVE = WS.mensagens.save;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      wrapper: Random(7),
      strings: STRINGS[window.LANGUAGE],
      detalhe: props.detalhe
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeMessage = this.onChangeMessage.bind(this);

    this.destinatario = 'destinatario';
    this.remetente = 'remetente';
  }

  componentDidMount() {
    var textarea = document.getElementById('mensagem-textarea');
    textarea.scrollTop = textarea.scrollHeight;
  }

  handleSubmit (e){
    e.preventDefault();
    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      digiteMensagem,
      erroSalvar,
      periodoGratuitoMsg
    }
    = this.state.strings;

    //retorna todos os exercicios adicionados
    let idForm = e.target.getAttribute('id');
    //transforma o formData em um json
    var object = {mensagem: this.state.mensagem, id: this.props.id};

    var msg;
    _self.props.modal.close();
    msg = {
      title: atencao,
      text: periodoGratuitoMsg
    };
    Dialog.create(msg);
  }

  getLista() {
    let lista = this.state.detalhe.map((value, i) =>
      <div key={i}>
        <div className={`msg-tipo msg-${value.tipo}`}>
          <div className='msg-date'>{value.data}</div>
          <div className='msg-value'>{value.mensagem}</div>
        </div>
        <div className='clear'></div>
      </div>
    );
    return(lista);
  }

  onChangeMessage(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render (){
    const { titleMensagens } = this.state.strings;
    const lista = this.getLista();
    const
    {
      digiteAqui,
      enviar
    } = this.state.strings;

    return (
      <div className='box-cadastro-bloco'>
        <MainTitle title={titleMensagens}></MainTitle>
        <div className='wrapper-messages' id='mensagem-textarea'>
          {lista}
        </div>
        <form id="form-new-message" onSubmit={this.handleSubmit}>
          <input type='hidden' name='id' value={this.props.id} />
          <div className="textarea-add-msg">
          <textarea name='mensagem' placeholder={digiteAqui}  onChange={this.onChangeMessage} ></textarea>
          </div>
          <br />
          <div className="box-right-button"><Button type="submit" text={enviar} classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/mensagens/Page.js